type AnyProps = object;

const isEventHandlerKey = (key: string): boolean => /^on[A-Z]/.test(key);

const isFn = (value: unknown): value is (...args: any[]) => unknown => typeof value === "function";

export const mergePropsWithEventHandlers = <T extends AnyProps, U extends AnyProps>(
  baseProps?: T | null,
  extraProps?: U | null,
): T & U => {
  const merged: Record<string, unknown> = { ...(baseProps as object ?? {}) };
  if (!extraProps) {
    return merged as T & U;
  }

  for (const key of Object.keys(extraProps as object)) {
    const baseValue = merged[key];
    const extraValue = (extraProps as Record<string, unknown>)[key];

    if (isEventHandlerKey(key) && isFn(baseValue) && isFn(extraValue)) {
      merged[key] = (...args: any[]) => {
        baseValue(...args);
        extraValue(...args);
      };
      continue;
    }

    merged[key] = extraValue;
  }

  return merged as T & U;
};
